webpackJsonp([3],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getTranslations = __webpack_require__(57);
	
	var _getTranslations2 = _interopRequireDefault(_getTranslations);
	
	var _acura = __webpack_require__(67);
	
	var _acura2 = _interopRequireDefault(_acura);
	
	var _cms = __webpack_require__(80);
	
	var _parseLayoutCmsData = __webpack_require__(92);
	
	var _parseLayoutCmsData2 = _interopRequireDefault(_parseLayoutCmsData);
	
	var _readConfigData = __webpack_require__(64);
	
	var _readConfigData2 = _interopRequireDefault(_readConfigData);
	
	var _mobile = __webpack_require__(559);
	
	var _geo = __webpack_require__(58);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _mobile2 = __webpack_require__(560);
	
	var _mobile3 = _interopRequireDefault(_mobile2);
	
	var _dom = __webpack_require__(114);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Acura.ca/old (Mobile)
	 *
	 * Entry point to the legacy Acura.ca mobile web client
	 *
	 */
	
	var cmsData = (0, _cms.parseData)(window.__pageContentData || {});
	var layoutCmsData = (0, _parseLayoutCmsData2.default)(cmsData);
	var config = (0, _readConfigData2.default)('acura-config');
	var windowWidth = (0, _dom.getWindowWidth)();
	
	var app = (0, _lodash.assign)({}, {
	  theme: _acura2.default,
	  isDesktop: false,
	  isMobile: true,
	  isResponsive: false,
	  modelsNavList: [],
	  env: ("production"),
	  version: ("3.4.5"),
	  outerContainerId: 'hui-layout-container',
	  pageWrapId: 'hui-content-container',
	  windowWidth: windowWidth,
	  windowHeight: (0, _dom.getWindowHeight)(),
	  menuPanelWidth: windowWidth,
	  vehiclePanelWidth: windowWidth,
	  firstPanelId: 'contentMenuMobile',
	  translations: (0, _getTranslations2.default)(config.language)
	}, config, layoutCmsData);
	
	(0, _mobile.renderNavs)(app);
	(0, _mobile.renderFooter)(app);
	
	_mobile3.default.init(app);
	_geo2.default.init(app);

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.renderNavs = renderNavs;
	exports.renderFooter = renderFooter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(36);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContentRoot = __webpack_require__(91);
	
	var _getContentRoot2 = _interopRequireDefault(_getContentRoot);
	
	var _AcuraNavigationManager = __webpack_require__(155);
	
	var _AcuraNavigationManager2 = _interopRequireDefault(_AcuraNavigationManager);
	
	var _AcuraNavigation = __webpack_require__(319);
	
	var _AcuraNavigation2 = _interopRequireDefault(_AcuraNavigation);
	
	var _Window = __webpack_require__(83);
	
	var _Window2 = _interopRequireDefault(_Window);
	
	var _AcuraFooter = __webpack_require__(154);
	
	var _AcuraFooter2 = _interopRequireDefault(_AcuraFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Render the main app that controls navigation components and such
	function renderNavs(props) {
	  return _reactDom2.default.render(_react2.default.createElement(
	    _Window2.default,
	    null,
	    _react2.default.createElement(
	      _AcuraNavigationManager2.default,
	      props,
	      _react2.default.createElement(_AcuraNavigation2.default, props)
	    )
	  ), (0, _getContentRoot2.default)('root'));
	}
	
	// Render the footer by itself wherever host supplies the DOM element
	function renderFooter(props) {
	  return _reactDom2.default.render(_react2.default.createElement(
	    _Window2.default,
	    null,
	    _react2.default.createElement(_AcuraFooter2.default, _extends({ menuItems: props.footerMenuItems }, props))
	  ), (0, _getContentRoot2.default)('footer'));
	}

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(252);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(8);
	
	var _dispatcher = __webpack_require__(136);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _constants = __webpack_require__(113);
	
	var _associations = __webpack_require__(358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var migrationsMobile = {
	  selectedProvinceCode: '',
	  init: function init(config) {
	    var _this = this;
	
	    _dispatcher2.default.on(_constants.EVENTS.ProvinceSelected, function (_ref) {
	      var province = _ref.province,
	          code = _ref.code,
	          postalCode = _ref.postalCode;
	
	      _this.updateDealerLocator(config, postalCode, code);
	      _this.updateSpecialOffers(config, code);
	      _this.updateTireWizard(postalCode, code);
	      _this.selectedProvinceCode = code;
	    });
	  },
	  getAssociations: function getAssociations(config) {
	    //TODO: need to get associations fro API
	    var fallbackAssociations = config.language === 'en' ? _associations.associationsFallbackData : _associations.associationsFalbackData_fr;
	    return fallbackAssociations;
	  },
	  updateDealerLocator: function updateDealerLocator(config, postalCode, provinceCode) {
	    if ((0, _jquery2.default)('#dealer-locator').length) {
	      window.updateDealerLocatorLocation(postalCode, provinceCode);
	    } else if ((0, _jquery2.default)('.dealer-locator.search-results').length) {
	      var url = config.language === 'en' ? '/dealerlocator' : '/trouver-concessionaire';
	
	      if (window.location.pathname !== url && ['', provinceCode].indexOf(this.selectedProvinceCode) < 0) window.location.href = url;
	    }
	  },
	  updateSpecialOffers: function updateSpecialOffers(config, provinceCode) {
	    if ((0, _jquery2.default)('#special-offers-page').length) {
	      var associations = this.getAssociations(config);
	      var association = (0, _lodash.find)(associations, { Province: { Abbreviation: provinceCode } });
	      var url = config.language === 'en' ? '/special-offers-national' : '/offres-speciales-national';
	      if (association) {
	        url = association.Url;
	      }
	      if (window.location.pathname.indexOf(url) < 0) window.location.href = url;
	    }
	  },
	  updateTireWizard: function updateTireWizard(postalCode, provinceCode) {
	    if ((0, _jquery2.default)('.tire-finder-wrapper .tire-wizard-region-contain').length) {
	      if (postalCode !== '') {
	        (0, _jquery2.default)('.tire-wizard-postal-contain input').val(postalCode);
	        (0, _jquery2.default)('.tire-wizard-btn-go').trigger('click');
	      }if (isProvinceCodeSupported(provinceCode)) {
	        (0, _jquery2.default)('.tire-wizard-region-contain select').val(provinceCode).trigger('onchange');
	      } else {
	        (0, _jquery2.default)('.tire-wizard-dealer-listing').hide();
	        (0, _jquery2.default)('.tire-wizard-region-contain select').val('-1');
	      }
	    }
	  }
	};
	
	function isProvinceCodeSupported(provinceCode) {
	  return [undefined, null, '', 'NT', 'NU', 'PE', 'YT'].indexOf(provinceCode) < 0;
	}
	
	window.updateDealerLocatorLocation = function (postalCode, provinceCode) {
	  if (postalCode !== '') {
	    (0, _jquery2.default)('.location-postal-code').val(postalCode);
	    (0, _jquery2.default)('.search-by-postal').trigger('click');
	  } else {
	    if (isProvinceCodeSupported(provinceCode)) {
	      (0, _jquery2.default)('select.location-province').val(provinceCode);
	      (0, _jquery2.default)('.search-by-region').trigger('click');
	    } else {
	      (0, _jquery2.default)('select.location-province').val('ON');
	    }
	  }
	};
	exports.default = migrationsMobile;

/***/ })

});


// WEBPACK FOOTER //
// mobile.js